import { useCallback, useEffect, useState } from "react";

import type { UserDTO } from "../../common/types/UserDTO";
import { useGetUserQuery } from "../store/services/user";
import { navigationChannel, VENUE_CHANGED } from "../utils/broadcastChannel";

// When loaded venue is changed in Identity Management iFrame
// Trigger a reload of the current user record to then pass the correct venueId to other iFrame apps
export const useVenueSelectionListener = (user?: UserDTO) => {
  const userId = user?.id;

  const [triggerRefetch, setTriggerRefetch] = useState(false);
  const { refetch } = useGetUserQuery(
    {
      // TODO Please correct typings soon
      // @ts-ignore
      id: userId,
    },
    { skip: !userId },
  );

  navigationChannel.addEventListener("message", (event: MessageEvent) => {
    if (event.data === VENUE_CHANGED) {
      setTriggerRefetch(true);
    }
  });

  const refetchUser = useCallback(() => {
    void refetch();
  }, [refetch]);

  useEffect(() => {
    if (triggerRefetch) {
      refetchUser();
      setTriggerRefetch(false);
    }
  }, [triggerRefetch, refetchUser]);
};
